import { StrikeMetadata } from 'models/forms/fields';
import type { Underlying, UnderlyingAssetType } from 'models/underlying';
import type { CommodityUnderlying } from 'models/underlying/commodity';
import type { CreditUnderlying } from 'models/underlying/credit';
import type { EquityUnderlying } from 'models/underlying/equity';
import type { ForexUnderlying } from 'models/underlying/forex';
import type { RateUnderlying } from 'models/underlying/rate';
import { FC } from 'react';

import { CommodityTable, CreditTable, EquityTable, ForexTable, RateTable } from './Tables';

export interface TableProps {
  assetType: UnderlyingAssetType;
  underlyings: Underlying[];

  strikeMetadata: StrikeMetadata;
}

export const Table: FC<TableProps> = ({ assetType = 'Equity', underlyings, strikeMetadata }) => {
  if (!underlyings || !underlyings.length) {
    return null;
  }

  return (
    <div data-e2e="selected-underlyings-list">
      {assetType === 'Commodity' && (
        <CommodityTable strikeMetadata={strikeMetadata} underlyings={underlyings as CommodityUnderlying[]} />
      )}
      {assetType === 'CreditRate' && <CreditTable underlyings={underlyings as CreditUnderlying[]} />}
      {assetType === 'Equity' && (
        <EquityTable strikeMetadata={strikeMetadata} underlyings={underlyings as EquityUnderlying[]} />
      )}
      {assetType === 'Forex' && <ForexTable underlyings={underlyings as ForexUnderlying[]} />}
      {assetType === 'Rate' && <RateTable underlyings={underlyings as RateUnderlying[]} />}
    </div>
  );
};

Table.displayName = 'UnderlyingsTable';
